import type { ProcurementStatus } from 'scheduler-types';

const statusColors: Record<ProcurementStatus, string> = {
  needed: 'bg-danger-subtle text-danger',
  claimed: 'bg-warning-subtle text-warning',
  ordered: 'bg-primary/10 text-primary',
  confirmed: 'bg-primary/10 text-primary',
  tracking: 'bg-primary/10 text-primary',
  received: 'bg-success-subtle text-success',
  released: 'bg-background-subtle text-foreground-muted',
  flagged: 'bg-danger-subtle text-danger',
};

const statusLabels: Record<ProcurementStatus, string> = {
  needed: 'Needed',
  claimed: 'Claimed',
  ordered: 'Ordered',
  confirmed: 'Confirmed',
  tracking: 'Tracking',
  received: 'Received',
  released: 'Released',
  flagged: 'Flagged',
};

export function StatusBadge({ status }: { status: ProcurementStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusColors[status] ?? 'bg-background-subtle text-foreground-muted'}`}
    >
      {statusLabels[status] ?? status}
    </span>
  );
}
